import api from './api';

/**
 * Address Service
 * Handles all address-related API operations
 */
export const addressService = {
  /**
   * Get all addresses for the authenticated user
   * @returns {Promise<{success: boolean, data: Address[]}>}
   */
  getAddresses: async () => {
    const response = await api.get('/addresses');
    return response.data;
  },

  /**
   * Get a specific address by ID
   * @param {string} addressId - UUID of the address
   * @returns {Promise<{success: boolean, data: Address}>}
   */
  getAddress: async (addressId) => {
    const response = await api.get(`/addresses/${addressId}`);
    return response.data;
  },

  /**
   * Create a new address
   * @param {AddressRequest} addressData - Address details
   * @returns {Promise<{success: boolean, data: Address}>}
   */
  createAddress: async (addressData) => {
    const response = await api.post('/addresses', addressData);
    return response.data;
  },

  /**
   * Update an existing address
   * @param {string} addressId - UUID of the address
   * @param {AddressRequest} addressData - Updated address details
   * @returns {Promise<{success: boolean, data: Address}>}
   */
  updateAddress: async (addressId, addressData) => {
    const response = await api.put(`/addresses/${addressId}`, addressData);
    return response.data;
  },

  /**
   * Delete an address
   * @param {string} addressId - UUID of the address
   * @returns {Promise<{success: boolean}>}
   */
  deleteAddress: async (addressId) => {
    const response = await api.delete(`/addresses/${addressId}`);
    return response.data;
  },

  /**
   * Set an address as default
   * @param {string} addressId - UUID of the address
   * @returns {Promise<{success: boolean, data: Address}>}
   */
  setDefaultAddress: async (addressId) => {
    const response = await api.patch(`/addresses/${addressId}/default`);
    return response.data;
  },
};
